import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=5da1ba66&scoped=true&"
import script from "./Scrollbar.vue?vue&type=script&lang=js&"
export * from "./Scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&id=5da1ba66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1ba66",
  null
  
)

export default component.exports